
import { Component } from "react";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import ExhibitorHeader from "../../../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../../../common_components/exhibitor_module_topmenu";



class Disclaimer extends Component {

    //Initialize constructor
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false
        }
    }

    render() {
        const { isLoading } = this.state
        return (

            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <ExhibitorHeader />
                <ExhibitorDrawer />
                <div className="main-content with-dr-container">
                    <div className="">
                        <div className="row">
                            <ExhibitorTopMenu />
                        </div>
                        <div className="row">
                            <div className="col-xl-12 p-1">
                                <div className="card rounded-0 pt-1">
                                    <div className="card-header p-3">
                                        <h3 className="card-title"> Disclaimer</h3>
                                    </div>
                                    <div className="card-body p-3 text-left">
                                        <div className="row ">
                                            <h6 className="mt-2">
                                                1) The cost/rates and terms &amp; conditions of utilizing the
                                                individual services from the given service provider is solely
                                                discretion of exhibitors.
                                            </h6>
                                            <h6 className="mt-2">
                                                2) India ITME Society is only information facilitator for the
                                                service provider &amp; in no event shall India ITME Society be
                                                liable for any direct, indirect, punitive, incidental, special
                                                consequential issues, whatsoever arising out of taking services
                                                with the above given service provider.
                                            </h6>
                                            <h5 className="mt-2">
                                                <b>
                                                    Kindly find the below details Agency for Customized Stall
                                                    Designer.
                                                </b>
                                            </h5>
                                            <div>
                                                <ul>
                                                    <li className="mb-1">Agency Name: Mr Pathik Patel</li>
                                                    <li className="mb-1">Contact Person: General Manager</li>
                                                    <li className="mb-1">
                                                        Company Name: Ovidian Advertising &amp; Design Ltd
                                                    </li>
                                                    <li className="mb-1">Email id: fc@ovidian.co.ke </li>
                                                    <li className="mb-1">Mobile No: + 254 (0)789 707 628 </li>
                                                    {/* <li className="mt-4 mb-1">
                                                        Agency Name: Mr Daniel Mesfin
                                                    </li>
                                                    <li className="mb-1">
                                                        Contact Person: Managing Director
                                                    </li>
                                                    <li className="mb-1">Company Name: Exhibit Africa</li>
                                                    <li className="mb-1">Email id: dm@exhibit-africa.com</li>
                                                    <li className="mb-1">
                                                        Mobile No: +251 991606060
                                                    </li> */}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </>
        )
    }
}
export default withRouter(connect(null, {})(Disclaimer))